import { Meta } from '@/components/Meta';

export function PrivacyPage() {
  return (
    <>
      <Meta title="Privacy — Rachele Dolcezze" />
      <div className="u-container max-w-3xl pt-[22vh] pb-[16vh]">
        <h1 className="font-display text-5xl md:text-7xl">Privacy</h1>
        <p className="mt-10 leading-relaxed text-ink-soft">
          Pagina dimostrativa. Qui andrà l'informativa privacy completa (titolare del trattamento,
          dati raccolti dal modulo d'ordine, base giuridica, conservazione e diritti dell'interessato)
          e la cookie policy, con i dati reali dell'attività prima della messa online.
        </p>
      </div>
    </>
  );
}
